import React from 'react';
import { useStyles } from './styles';
import { InputAdornment } from '@mui/material';
import { Error } from '@mui/icons-material';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { UPDATE_PARTNER_ACCOUNT_EMPLOYEE } from '../../../../actions/update';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import {Box, ButtonV2, InputV2, Typography} from "@/elements";
import {trimHandler} from "@/utils/trimHandler.js";

const User = ({ user, data, query }) => {
    const classes = useStyles();

    const [setInfo] = useMutation(UPDATE_PARTNER_ACCOUNT_EMPLOYEE);

    const onSubmit = inputData => {
        setInfo({
            variables: {
                first: inputData.firstName,
                last: inputData.lastName,
                id: user && user.id,
            },
            refetchQueries: [
                {
                    query: query,
                    variables: {
                        id: user && user.id,
                    },
                },
            ],
        })
            .then(() => toast.success('Success'))
            .catch(err => toast.error(err.message));
    };

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required('Current First Name is required').min(3, 'Please enter at least 3 characters'),
        lastName: Yup.string().required('Current Last Name is required').min(3, 'Please enter at least 3 characters'),
        email: Yup.mixed().nullable(),
    });

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    return (
        <Box direction="column" gap="20px" $minWidth="340px">
            <Typography variant="h6">
                User Information
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box direction="column" gap="20px" width="550px">
                    <Controller
                        name="firstName"
                        control={control}
                        defaultValue={data?.partnerAccountEmployee?.name?.first || ''}
                        render={({ field: { onChange, onBlur, value } }) => (
                            <InputV2
                                onChange={onChange}
                                value={value}
                                label="First Name"
                                onBlur={(e) => {
                                    trimHandler(e.target.value, onBlur, onChange)
                                }}
                                error={!!errors.firstName}
                                helperText={errors?.firstName?.message ?? ' '}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">{errors.firstName ? <Error color="error" /> : ''}</InputAdornment>,
                                }}
                            />
                        )}
                    />
                    <Controller
                        name="lastName"
                        control={control}
                        defaultValue={data?.partnerAccountEmployee?.name?.last || ''}
                        render={({ field: { onChange,onBlur, value } }) => (
                            <InputV2
                                onChange={onChange}
                                value={value}
                                label="Last Name"
                                onBlur={(e) => {
                                    trimHandler(e.target.value, onBlur, onChange)
                                }}
                                error={!!errors.lastName}
                                helperText={errors?.lastName?.message ?? ' '}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">{errors.lastName ? <Error color="error" /> : ''}</InputAdornment>,
                                }}
                            />
                        )}
                    />

                    <Controller
                        name="email"
                        control={control}
                        defaultValue={data?.partnerAccountEmployee?.name?.last || ''}
                        render={({ field: { onChange,onBlur, value } }) => (
                        <InputV2
                            value={value}
                            onChange={onChange}
                            disabled
                            defaultValue={data?.partnerAccountEmployee?.email}
                            label="Email"
                            onBlur={(e) => {
                                trimHandler(e.target.value, onBlur, onChange)
                            }}
                        />
                        )}
                    />
                    <div className={classes.buttonWrapper}>
                        <ButtonV2 type="submit">
                            Save
                        </ButtonV2>
                    </div>
                </Box>
            </form>
        </Box>
    );
};

export default User;
